<div *ngIf="loadComplete" class="container-block">

  <ng-container *ngIf="!isViewAll">
    <app-position-in-config [elementChoosing]="objectChoosing" [device]="device"
      [idCellFrame]="'cell_frame_'+ objectChoosing._id + '_' +'0'"></app-position-in-config>

    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device"
      [id_parent_choose]=" objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object"></app-position-out-config>

    <app-width-height-config [device]="device" [elementChoosing]="objectChoosing"
      [width]="class['frame-search-by-keyword']['width']" [height]="class['frame-search-by-keyword']['height']"
      (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      
      <!-- Cấu hình thông số cơ bản -->
      <li nz-submenu nzTitle="{{'thong_so_co_ban' | translate}}" [(nzOpen)]="openMenu.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <div class="main-config">
          <div *ngIf="objectChoosing.type !== 'frame_search_by_keyword_category'" class="flex flex-column gap-2">
            <p class="m-0" style="line-height: 1.5">{{'hien_thi_tat_ca_san_pham_theo_danh_muc_co_dinh' | translate}}</p>
            <div class="custom-select-wrapper">
              <div class="custom-select" (click)="toggleDropdown($event)">
                {{ config.fixed_id_category === 'none' ? ('khong' | translate) : (currentCategory?.['name_' + functionService.selectedLanguageCode] ?? ('chon_danh_muc' | translate)) }}
                <span class="arrow"></span>
              </div>
              
              <div *ngIf="openFixedIdCate">
                <input type="text" [placeholder]="'tim_kiem_danh_muc' | translate" 
                  [(ngModel)]="searchCategory" 
                  (ngModelChange)="onSearchCategoryChange($event)"
                  id="searchCategory" name="searchCategory" />
                <p style="text-align: center" *ngIf="searchCategory != '' && resultSearchCategory.length == 0 && isLoadingSearchCategory == false">
                  {{ 'khong_tim_thay_ket_qua' | translate }}
                </p>
                <ul *ngIf="tempSearchCategory == ''" class="custom-options">
                  <li (click)="chooseCategory('none')"
                    [class.selected]="config.fixed_id_category === 'none'">
                    {{'khong' | translate}}
                  </li>
                  <li 
                    *ngFor="let category of categories; trackBy: trackByPage"
                    [attr.data-id]="category._id"
                    (click)="chooseCategory(category)"
                    [class.selected]="category === currentCategory">
                    {{ category['name_' + functionService.selectedLanguageCode] }}
                  </li>
                </ul>
                <ul 
                  *ngIf="searchCategory != '' &&  tempSearchCategory != '' && isLoadingSearchCategory == false" 
                  class="custom-options">
                  <li 
                    *ngFor="let category of resultSearchCategory; trackBy: trackByPage"
                    [attr.data-id]="category._id"
                    (click)="chooseCategory(category)"
                    [class.selected]="category === currentCategory">
                    {{ category['name_' + functionService.selectedLanguageCode] }}
                  </li>
                </ul>
                <!-- loading -->
                <div *ngIf="isLoadingSearchCategory" style="text-align: center; padding-top: 34px;">
                  <span  nz-icon [nzType]="'loading'"></span>
                </div>
              </div>
            </div>
          </div>
          <!-- Option màu nền cho frame -->
          <app-background-image-config [showImageConfig]="false" [config]="config" [class]="class"
            [backgroundClass]="class['frame-search-by-keyword']" [backgroundConfig]="config['frame-search-by-keyword']"
            [isBlock]="false" [id_object]="objectChoosing._id" [device]="device">
          </app-background-image-config>

          <!-- Thay đổi màu thẻ chứa cụm nút phân trang-->
          <div class="config-name">
            <p>{{'mau_nen_cum_nut_phan_trang' | translate}}</p>
            <input class="input-color" type="button"
              [style.background]="class['frame-search-by-keyword__pagination']['background-color']"
              [cpOKButton]="true" [(colorPicker)]="class['frame-search-by-keyword__pagination']['background-color']"
              (colorPickerClose)="updateClass()" />
          </div>
        </div>
      </li>
      <!-- Cấu hình icon bên trái -->
      <li *ngIf="config['frame-search-by-keyword__products']['is_autoplay']" nz-submenu
        nzTitle="{{'cau_hinh_icon_trai' | translate}}" [(nzOpen)]="openMenu.menu6"
        (nzOpenChange)="openHandler('menu6')">
        <app-icon-left-config [device]="device" [class]="class" [config]="config"
          [iconLeftClass]="class['frame-search-by-keyword__left-arrow--icon']"
          [iconLeftConfig]="config['frame-search-by-keyword__left-arrow--icon']"
          [distanceLeftClass]="class['frame-search-by-keyword__left-arrow']" [id_object]="objectChoosing._id">
        </app-icon-left-config>
      </li>
      <!-- Cấu hình icon bên phải -->
      <li *ngIf="config['frame-search-by-keyword__products']['is_autoplay']" nz-submenu
        nzTitle="{{'cau_hinh_icon_phai' | translate}}" [(nzOpen)]="openMenu.menu7"
        (nzOpenChange)="openHandler('menu7')">
        <app-icon-right-config [device]="device" [class]="class" [config]="config"
          [iconRightClass]="class['frame-search-by-keyword__right-arrow--icon']"
          [iconRightConfig]="config['frame-search-by-keyword__right-arrow--icon']"
          [distanceRightClass]="class['frame-search-by-keyword__right-arrow']" [id_object]="objectChoosing._id">
        </app-icon-right-config>
      </li>
      <!-- Cấu hình chung -->
      <li nz-submenu nzTitle="{{'cau_hinh_chung' | translate}}" [(nzOpen)]="openMenu.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <app-total-row-col-products-config [config]="config" [class]="class"
          [productsClass]="class['frame-search-by-keyword__products']"
          [productsConfig]="config['frame-search-by-keyword__products']" [id_object]="objectChoosing._id"
          [device]="device">
        </app-total-row-col-products-config>

        <!-- Khoảng đệm -->
        <div>
          <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
            [classPadding]="class['frame-search-by-keyword__products']" [paddingConfigs]="[
              { type: 'top' },
              { type: 'bottom' },
              { type: 'left' },
              { type: 'right' }
            ]">
          </app-padding-config>
        </div>
      </li>
      <!-- <li 
        nz-submenu nzTitle="{{'chon_nganh_hang' | translate}}" 
        [(nzOpen)]="openMenu.menu10" 
        (nzOpenChange)="openHandler('menu10')" >
        <mat-form-field appearance="fill" >
          <mat-label>{{'chon_nganh_hang' | translate}}</mat-label>
          <mat-select [(ngModel)]="staticdata.main_sector" (ngModelChange)="updateStaticData()">
            <mat-option *ngFor="let main_sector of main_sectors"  [value]="main_sector.value">{{main_sector.label}}</mat-option>
          </mat-select>
        </mat-form-field>

      </li> -->
      <!-- Nút phân trang -->
      <li nz-submenu nzTitle="{{'nut_phan_trang' | translate}}" [(nzOpen)]="openMenu.menu3"
        (nzOpenChange)="openHandler('menu3')">
        <div class="pl-1" nz-submenu nzTitle="{{'thiet_lap_chung' | translate}}">
          <div class="editor-field">
            <!-- Ẩn nút phân trang -->
            <div class="config-name" style="padding-bottom:5px">
              <div class="title-font">
                {{'an_nut_phan_trang' | translate}}
              </div>
              <nz-switch [(ngModel)]="config['frame-search__pagination']['hide_pagination']" (ngModelChange)="class['frame-search-by-keyword__pagination']['display'] =
                !$event ? 'flex' : 'none';updateConfig();updateClass()"></nz-switch>
            </div>
            <!-- Vị trí cụm nút phân trang -->
            <div>
              <div class="title mb-1 mt-0" style="padding-bottom: 3px;">{{'vi_tri_cum_nut_phan_trang' | translate}}
              </div>
              <nz-radio-group style="display:flex; flex-direction:column;"
                [(ngModel)]="class['frame-search-by-keyword__pagination']['justify-content']"
                (ngModelChange)="updateClass()">
                <label nz-radio nzValue="flex-start">{{'trai' | translate}}</label>
                <label nz-radio nzValue="center">{{'giua' | translate}}</label>
                <label nz-radio nzValue="flex-end">{{'phai' | translate}}</label>
              </nz-radio-group>
            </div>
            <!-- Khoảng cách giữa các nút -->
            <div>
              <div class="config-name mb-0">
                <p>{{'khoang_cach_giua_cac_nut' | translate}}</p>
                <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="1"
                  [ngModel]="class['frame-search-by-keyword__pagination-list-button']['gap'] | vhnumber"
                  (ngModelChange)="class['frame-search-by-keyword__pagination-list-button']['gap'] = $event + 'px'"
                  (nzBlur)="updateClass()">
                </nz-input-number>
              </div>
              <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
                [ngModel]="class['frame-search-by-keyword__pagination-list-button']['gap'] | vhnumber"
                (ngModelChange)="class['frame-search-by-keyword__pagination-list-button']['gap'] = $event + 'px'"
                (nzOnAfterChange)="updateClass()">
              </nz-slider>
            </div>

            <!-- Khoảng cách giữa các nút với cột sản phẩm -->
            <div>
              <div class="config-name mb-0">
                <p>{{'khoang_cach_giua_nut_va_san_pham' | translate}}</p>
                <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="1"
                  [ngModel]="class['frame-search-by-keyword__products']['padding-bottom'] | vhnumber"
                  (ngModelChange)="class['frame-search-by-keyword__products']['padding-bottom'] = $event + 'px'"
                  (nzBlur)=" updateClass()">
                </nz-input-number>
              </div>
              <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
                [ngModel]="class['frame-search-by-keyword__products']['padding-bottom'] | vhnumber"
                (ngModelChange)="class['frame-search-by-keyword__products']['padding-bottom'] = $event + 'px'"
                (nzOnAfterChange)=" updateClass()">
              </nz-slider>
            </div>

            <!--Chỉnh chiều cao của cụm nút phân trang-->
            <div>
              <div class="config-name mb-0">
                <p>{{'chieu_cao_cua_cum_nut_phan_trang' | translate}}</p>
                <nz-input-number [nzMin]="50" [nzMax]="100" [nzStep]="1"
                  [ngModel]="class['frame-search-by-keyword__pagination']['height'] | vhnumber"
                  (ngModelChange)="class['frame-search-by-keyword__pagination']['height'] = $event + 'px'"
                  (nzBlur)=" updateClass()">
                </nz-input-number>
              </div>
              <nz-slider [nzMin]="50" [nzMax]="100" [nzStep]="1"
                [ngModel]="class['frame-search-by-keyword__pagination']['height'] | vhnumber"
                (ngModelChange)="class['frame-search-by-keyword__pagination']['height'] = $event + 'px'"
                (nzOnAfterChange)=" updateClass()">
              </nz-slider>
            </div>

            <!--Ẩn nút biểu tượng-->
            <div>
              <div class="config-name mb-0">
                <p>{{'an_nut_bieu_tuong' | translate}}</p>
                <nz-switch [(ngModel)]="config['icon_pagination']['display']" (ngModelChange)="class['frame-search-by-keyword__pagination-list-button--controll']['display'] =
                                  !$event ? 'flex' : 'none'" (nzOnAfterChange)="updateClass()"></nz-switch>
              </div>
            </div>
            <!--Ẩn nút Tới trang-->
            <div>
              <div class="config-name mb-0">
                <p>{{'an_nut_toi_trang' | translate}}</p>
                <nz-switch [(ngModel)]="config['goToPage_pagination']['display']"
                  (ngModelChange)="updateConfig()"></nz-switch>
              </div>
            </div>
            <!-- Chọn Font -->
            <div class="config-name mb-0">
              <mat-form-field class="w-100">
                <mat-label>Font</mat-label>
                <mat-select [(ngModel)]="class['frame-search-by-keyword__pagination-list-button']['font-family']"
                  (ngModelChange)="updateClass()">
                  <mat-option *ngFor="let font of fonts" [value]="font.value">
                    {{font.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <!-- set HCN hoặc Hình Tròn -->
            <div>
              <div class="config-name mb-0" style="flex-direction: column;">
                <p class="mb-3">{{'kieu_nut_slide' | translate}}</p>
                <nz-radio-group [(ngModel)]="config['slick_dots']['background_style']"
                  (ngModelChange)="handleSetDotsStyle($event)">
                  <label nz-radio nzValue="circle">{{'hinh_tron' | translate}}</label>
                  <label nz-radio nzValue="rectangle">{{'hinh_chu_nhat' | translate}}</label>
                </nz-radio-group>
                <!-- Kích thước nút (chiều rộng) -->
                <div *ngIf="config['slick_dots']['background_style'] == 'circle'">
                  <div class="config-name">
                    <p>{{'kich_thuoc_nut' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="80" [nzStep]="1"
                      [ngModel]="config['slick_dots']['width'] | vhnumber" (ngModelChange)="handleSetButtonSize($event)"
                      (nzOnAfterChange)="updateConfig(); updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="80" [nzStep]="1" [ngModel]="config['slick_dots']['width'] | vhnumber"
                    (ngModelChange)="handleSetButtonSize($event)" (nzOnAfterChange)="updateConfig(); updateClass()">
                  </nz-slider>
                </div>
                <!-- Kích thước nút (chiều cao) -->
                <div *ngIf="config['slick_dots']['background_style'] == 'rectangle'">
                  <div class="config-name">
                    <p>{{'kich_thuoc_nut_chieu_rong' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="80" [nzStep]="1"
                      [ngModel]="config['slick_dots']['width'] | vhnumber"
                      (ngModelChange)="config['slick_dots']['width'] = $event+'px'"
                      (nzBlur)="updateConfig(); updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="80" [nzStep]="1" [ngModel]="config['slick_dots']['width'] | vhnumber"
                    (ngModelChange)="config['slick_dots']['width'] = $event+'px'"
                    (nzOnAfterChange)="updateConfig(); updateClass()">
                  </nz-slider>
                  <div class="config-name">
                    <p>{{'kich_thuoc_nut_chieu_cao' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="80" [nzStep]="1"
                      [ngModel]="config['slick_dots']['height'] | vhnumber"
                      (ngModelChange)="config['slick_dots']['height'] = $event+'px'"
                      (nzBlur)="updateConfig(); updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="80" [nzStep]="1" [ngModel]="config['slick_dots']['height'] | vhnumber"
                    (ngModelChange)="config['slick_dots']['height'] = $event+'px'"
                    (nzOnAfterChange)="updateConfig(); updateClass()">
                  </nz-slider>
                </div>
              </div>

            </div>
          </div>
        </div>
        <!-- Thiết lập nút chưa chọn -->
        <div class="px-1 li-config" nz-submenu nzTitle="{{'thiet_lap_nut_chua_chon' | translate}}"
          [(nzOpen)]="openMenu.menu6">
          <!-- Màu chữ -->
          <div class="config-name">
            <div class="title-font" style="width: 80%">{{'mau_chu' | translate}}</div>
            <div class="color-pick" style="width: 88%">
              <input class="input-color" style="width: 78%" type="button"
                [cpOKButton]="true" [(colorPicker)]="class['frame-search-by-keyword__pagination-list-button--page-number']['color']"
                [style.background]="class['frame-search-by-keyword__pagination-list-button--page-number']['color']"
                (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Cỡ chữ -->
          <div>
            <div class="config-name mb-0">
              <p>{{'co_chu' | translate}}</p>
              <nz-input-number [nzMin]="1" [nzMax]="100" [nzStep]="1"
                [ngModel]="class['frame-search-by-keyword__pagination-list-button--page-number']['font-size'] | vhnumber"
                (ngModelChange)="class['frame-search-by-keyword__pagination-list-button--page-number']['font-size'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="1" [nzMax]="100" [nzStep]="1"
              [ngModel]="class['frame-search-by-keyword__pagination-list-button--page-number']['font-size'] | vhnumber"
              (ngModelChange)="class['frame-search-by-keyword__pagination-list-button--page-number']['font-size'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <hr class="my-4" style="border-top: 1px solid rgb(223 223 223)" />
          <!-- Màu viền nút -->
          <div class="config-name">
            <div class="title-font" style="width: 80%">{{'mau_vien_nut' | translate}}</div>
            <div class="color-pick" style="width: 88%">
              <input class="input-color" style="width: 78%" type="button"
                [cpOKButton]="true" [(colorPicker)]="class['frame-search-by-keyword__pagination-list-button--page-number']['border-color']"
                [style.background]="class['frame-search-by-keyword__pagination-list-button--page-number']['border-color']"
                (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Độ dày viền -->
          <div>
            <div class="config-name mb-0">
              <p>{{'do_day_vien' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="8" [nzStep]="1"
                [ngModel]="class['frame-search-by-keyword__pagination-list-button--page-number']['border-width'] | vhnumber"
                (ngModelChange)="class['frame-search-by-keyword__pagination-list-button--page-number']['border-width'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="8" [nzStep]="1"
              [ngModel]="class['frame-search-by-keyword__pagination-list-button--page-number']['border-width'] | vhnumber"
              (ngModelChange)="class['frame-search-by-keyword__pagination-list-button--page-number']['border-width'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <hr class="my-4" style="border-top: 1px solid rgb(223 223 223)" />
          <!-- Màu nền -->
          <div class="config-name">
            <div class="title-font" style="width: 80%">{{'mau_nen' | translate}}</div>
            <div class="color-pick" style="width: 88%">
              <input class="input-color" style="width: 78%" type="button"
                [cpOKButton]="true" [(colorPicker)]="class['frame-search-by-keyword__pagination-list-button--page-number']['background-color']"
                [style.background]="
                  class['frame-search-by-keyword__pagination-list-button--page-number']['background-color']
                " [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Bo tròn -->
          <div>
            <div class="config-name mb-0">
              <p>{{'bo_tron' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="1"
                [ngModel]="class['frame-search-by-keyword__pagination-list-button--page-number']['border-radius'] | vhnumber"
                (ngModelChange)="class['frame-search-by-keyword__pagination-list-button--page-number']['border-radius'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
              [ngModel]="class['frame-search-by-keyword__pagination-list-button--page-number']['border-radius'] | vhnumber"
              (ngModelChange)="class['frame-search-by-keyword__pagination-list-button--page-number']['border-radius'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <hr class="my-4" style="border-top: 1px solid rgb(223 223 223)" />
          <!-- Khoảng đệm nút phân trang chưa chọn -->
          <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
            [classPadding]="class['frame-search-by-keyword__pagination-list-button--page-number']" [paddingConfigs]="[
            { type: 'top' },
            { type: 'bottom' },
            { type: 'left' },
            { type: 'right' }
          ]">
          </app-padding-config>
        </div>
        <!-- Thiết lập nút được chọn -->
        <div class="px-1 li-config" nz-submenu nzTitle="{{'thiet_lap_nut_duoc_chon' | translate}}"
          [(nzOpen)]="openMenu.menu7">
          <!-- Màu chữ -->
          <div class="config-name">
            <div class="title-font" style="width: 80%">{{'mau_chu' | translate}}</div>
            <div class="color-pick" style="width: 88%">
              <input class="input-color" style="width: 78%" type="button"
                [cpOKButton]="true" [(colorPicker)]="class['frame-search-by-keyword__pagination-list-button--active']['color']"
                [style.background]="class['frame-search-by-keyword__pagination-list-button--active']['color']"
                [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Cỡ chữ -->
          <div>
            <div class="config-name mb-0">
              <p>{{'co_chu' | translate}}</p>
              <nz-input-number [nzMin]="1" [nzMax]="100" [nzStep]="1"
                [ngModel]="class['frame-search-by-keyword__pagination-list-button--active']['font-size'] | vhnumber"
                (ngModelChange)="class['frame-search-by-keyword__pagination-list-button--active']['font-size'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="1" [nzMax]="100" [nzStep]="1"
              [ngModel]="class['frame-search-by-keyword__pagination-list-button--active']['font-size'] | vhnumber"
              (ngModelChange)="class['frame-search-by-keyword__pagination-list-button--active']['font-size'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <hr class="my-4" style="border-top: 1px solid rgb(223 223 223)" />
          <!-- Màu viền nút -->
          <div class="config-name">
            <div class="title-font" style="width: 80%">{{'mau_vien_nut' | translate}}</div>
            <div class="color-pick" style="width: 88%">
              <input class="input-color" style="width: 78%" type="button"
                [cpOKButton]="true" [(colorPicker)]="class['frame-search-by-keyword__pagination-list-button--active']['border-color']"
                [style.background]="class['frame-search-by-keyword__pagination-list-button--active']['border-color']"
                [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Độ dày viền -->
          <div>
            <div class="config-name mb-0">
              <p>{{'do_day_vien' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="8" [nzStep]="1"
                [ngModel]="class['frame-search-by-keyword__pagination-list-button--active']['border-width'] | vhnumber"
                (ngModelChange)="class['frame-search-by-keyword__pagination-list-button--active']['border-width'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="8" [nzStep]="1"
              [ngModel]="class['frame-search-by-keyword__pagination-list-button--active']['border-width'] | vhnumber"
              (ngModelChange)="class['frame-search-by-keyword__pagination-list-button--active']['border-width'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <hr class="my-4" style="border-top: 1px solid rgb(223 223 223)" />
          <!-- Màu nền -->
          <div class="config-name">
            <div class="title-font" style="width: 80%">{{'mau_nen' | translate}}</div>
            <div class="color-pick" style="width: 88%">
              <input class="input-color" style="width: 78%" type="button"
                [cpOKButton]="true" [(colorPicker)]="class['frame-search-by-keyword__pagination-list-button--active']['background-color']"
                [style.background]="class['frame-search-by-keyword__pagination-list-button--active']['background-color']"
                [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Bo tròn -->
          <div>
            <div class="config-name mb-0">
              <p>{{'bo_tron' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="1"
                [ngModel]="class['frame-search-by-keyword__pagination-list-button--active']['border-radius'] | vhnumber"
                (ngModelChange)="class['frame-search-by-keyword__pagination-list-button--active']['border-radius'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
              [ngModel]="class['frame-search-by-keyword__pagination-list-button--active']['border-radius'] | vhnumber"
              (ngModelChange)="class['frame-search-by-keyword__pagination-list-button--active']['border-radius'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <hr class="my-4" style="border-top: 1px solid rgb(223 223 223)" />
          <!-- Khoảng đệm nút phân trang được chọn -->
          <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
            [classPadding]="class['frame-search-by-keyword__pagination-list-button--active']" [paddingConfigs]="[
            { type: 'top' },
            { type: 'bottom' },
            { type: 'left' },
            { type: 'right' }
          ]">
          </app-padding-config>
        </div>
        <!-- Thiết lập nút chuyển trang -->
        <div class="px-1 li-config" nz-submenu nzTitle="{{'thiet_lap_nut_chuyen_trang' | translate}}"
          [(nzOpen)]="openMenu.menu8">
          <!-- Sử dụng icon -->
          <div class="config-name">
            <div class="title-font">{{'su_dung_icon' | translate}}</div>
            <nz-switch [(ngModel)]="config.icon_pagination.icon" (ngModelChange)="updateConfig()"></nz-switch>
          </div>
          <!-- Kiểu icon -->
          <div class="config-name">
            <div class="title-font">{{'kieu_icon' | translate}}</div>
            <button [disabled]="!config.icon_pagination.icon" nz-button nz-dropdown [nzDropdownMenu]="menu" style="
                  width: 50%;
                  padding: 0;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                " [nzPlacement]="positionSelect">
              <div style="
                    font-size: 18px;
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                  ">
                <i [class]="config.icon_pagination.arrow_left_icon"></i>
                <i [class]="config.icon_pagination.arrow_right_icon"></i>
              </div>
            </button>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu>
                <li nz-menu-item *ngFor="let item of bootstrapIconArrows" style="justify-content: center"
                  (click)="onChangeArrows(item)">
                  <div style="
                        font-size: 18px;
                        display: flex;
                        justify-content: space-around;
                        padding: 10px 0px;
                      ">
                    <i [class]="item.icon_left"></i>
                    <i [class]="item.icon_right"></i>
                  </div>
                </li>
              </ul>
            </nz-dropdown-menu>
          </div>
          <div class="config-name">
            <div class="title-font">{{'su_dung_noi_dung' | translate}}</div>
          </div>
          <!-- chọn ngôn ngữ đa ngôn ngữ -->
          <div *ngIf="!config.icon_pagination.icon" class="field-row my-3">
            
          </div>
          <div class="config-name">
            <div class="title-font">{{'truoc' | translate}}</div>
            <input [disabled]="config.icon_pagination.icon" style="width: 50%" nz-input
              placeholder="{{'truoc' | translate}}"
              [ngModel]="config.content_pagination['content_left_' + functionService.selectedLanguageCode] | vhLanguage : 'content_left' : objectChoosing.component" 
              (ngModelChange)="config.content_pagination['content_left_' + functionService.selectedLanguageCode] = $event" 
              (blur)="updateConfig()" />
          </div>
          <div class="config-name">
            <div class="title-font">{{'sau' | translate}}</div>
            <input [disabled]="config.icon_pagination.icon" style="width: 50%" nz-input
              placeholder="{{'sau' | translate}}"
              [ngModel]="config.content_pagination['content_right_' + functionService.selectedLanguageCode] | vhLanguage : 'content_right' : objectChoosing.component" 
              (ngModelChange)="config.content_pagination['content_right_' + functionService.selectedLanguageCode] = $event" 
              (blur)="updateConfig()" />
          </div>
          <!-- Màu nền -->
          <div class="config-name">
            <div class="title-font" style="width: 80%">{{'mau_nen' | translate}}</div>
            <div class="color-pick" style="width: 88%">
              <input class="input-color" style="width: 78%" type="button"
                [cpOKButton]="true" [(colorPicker)]="class['frame-search-by-keyword__pagination-list-button--controll']['background-color']"
                [style.background]="class['frame-search-by-keyword__pagination-list-button--controll']['background-color']"
                [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Màu chữ -->
          <div class="config-name">
            <div class="title-font" style="width: 80%">{{'mau_chu' | translate}}</div>
            <div class="color-pick" style="width: 88%">
              <input class="input-color" style="width: 78%" [cpPositionOffset]="'-200%'" [cpWidth]="'230px'"
                [cpPositionRelativeToArrow]="true" type="button"
                [cpOKButton]="true" [(colorPicker)]="class['frame-search-by-keyword__pagination-list-button--controll']['color']"
                [style.background]="class['frame-search-by-keyword__pagination-list-button--controll']['color']"
                [cpPosition]="'top'" (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Kích thước -->
          <div>
            <div class="config-name mb-0">
              <p>{{'co_chu' | translate}}</p>
              <nz-input-number [nzMin]="1" [nzMax]="100" [nzStep]="1"
                [ngModel]="class['frame-search-by-keyword__pagination-list-button--controll']['font-size'] | vhnumber"
                (ngModelChange)="class['frame-search-by-keyword__pagination-list-button--controll']['font-size'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="1" [nzMax]="100" [nzStep]="1"
              [ngModel]="class['frame-search-by-keyword__pagination-list-button--controll']['font-size'] | vhnumber"
              (ngModelChange)="class['frame-search-by-keyword__pagination-list-button--controll']['font-size'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <!-- Độ dày viền -->
          <div>
            <div class="config-name mb-0">
              <p>{{'do_day_vien' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="8" [nzStep]="1"
                [ngModel]="class['frame-search-by-keyword__pagination-list-button--controll']['border-width'] | vhnumber"
                (ngModelChange)="class['frame-search-by-keyword__pagination-list-button--controll']['border-width'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="8" [nzStep]="1"
              [ngModel]="class['frame-search-by-keyword__pagination-list-button--controll']['border-width'] | vhnumber"
              (ngModelChange)="class['frame-search-by-keyword__pagination-list-button--controll']['border-width'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <!-- Chọn màu viền -->
          <div class="config-name">
            <div class="title-font" style="width: 80%">{{'chon_mau_vien' | translate}}</div>
            <div class="color-pick" style="width: 57%">
              <input class="input-color" style="width: 100%" [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true"
                [cpOKButton]="true" [(colorPicker)]="class['frame-search-by-keyword__pagination-list-button--controll']['border-color']"
                [style.background]="class['frame-search-by-keyword__pagination-list-button--controll']['border-color']"
                (colorPickerClose)="updateClass()"  type="button"/>
            </div>
          </div>
          <!-- Bo tròn -->
          <div>
            <div class="config-name mb-0">
              <p>{{'bo_tron' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="1"
                [ngModel]="class['frame-search-by-keyword__pagination-list-button--controll']['border-radius'] | vhnumber"
                (ngModelChange)="class['frame-search-by-keyword__pagination-list-button--controll']['border-radius'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
              [ngModel]="class['frame-search-by-keyword__pagination-list-button--controll']['border-radius'] | vhnumber"
              (ngModelChange)="class['frame-search-by-keyword__pagination-list-button--controll']['border-radius'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
        </div>
        <!-- Thiết lập nút chuyển trang -->
        <div *ngIf="!config['goToPage_pagination']['display']" class="px-1 li-config" nz-submenu
          nzTitle="Thiết lập nút tới trang" [(nzOpen)]="openMenu.menu9">

          <div class="config-name">
            <div class="title-font">{{'su_dung_noi_dung' | translate}}</div>
          </div>
          <!-- chọn ngôn ngữ đa ngôn ngữ -->
          <div class="field-row mb-3">
            
          </div>
          <div class="config-name">
            <div class="title-font">{{'toi_trang' | translate}}</div>
            <input style="width: 50%" nz-input placeholder="{{'toi_trang' | translate}}"
              [ngModel]="config['goToPage_pagination']['content_goToPage_' + functionService.selectedLanguageCode] | vhLanguage : 'content_goToPage' : objectChoosing.component" 
              (ngModelChange)="config['goToPage_pagination']['content_goToPage_' + functionService.selectedLanguageCode] = $event" 
              (blur)="updateConfig()" />
          </div>
          <!-- Màu nền -->
          <div class="config-name">
            <div class="title-font" style="width: 80%">{{'mau_nen' | translate}}</div>
            <div class="color-pick" style="width: 88%">
              <input class="input-color" style="width: 78%" type="button"
                [cpOKButton]="true" [(colorPicker)]="config['goToPage_pagination']['background_color']"
                [style.background]="config['goToPage_pagination']['background_color']"
                (colorPickerClose)="updateConfig()" />
            </div>
          </div>
          <!-- Màu chữ -->
          <div class="config-name">
            <div class="title-font" style="width: 80%">{{'mau_chu' | translate}}</div>
            <div class="color-pick" style="width: 88%">
              <input class="input-color" style="width: 78%" type="button" [cpOKButton]="true" [(colorPicker)]="config['goToPage_pagination']['color']"
                [style.background]="config['goToPage_pagination']['color']" (colorPickerClose)="updateConfig()" />
            </div>
          </div>
          <!-- Kích thước -->
          <div>
            <div class="config-name mb-0">
              <p>{{'co_chu' | translate}}</p>
              <nz-input-number [nzMin]="1" [nzMax]="100" [nzStep]="1"
                [ngModel]="config['goToPage_pagination']['font_size'] | vhnumber"
                (ngModelChange)="config['goToPage_pagination']['font_size'] = $event + 'px'" (nzBlur)="updateConfig()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="1" [nzMax]="100" [nzStep]="1"
              [ngModel]="config['goToPage_pagination']['font_size'] | vhnumber"
              (ngModelChange)="config['goToPage_pagination']['font_size'] = $event + 'px'"
              (blur)="updateConfig()">
            </nz-slider>
          </div>
          <!-- Độ dày viền -->
          <div>
            <div class="config-name mb-0">
              <p>{{'do_day_vien' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="8" [nzStep]="1"
                [ngModel]="config['goToPage_pagination']['border_width'] | vhnumber"
                (ngModelChange)="config['goToPage_pagination']['border_width'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="8" [nzStep]="1"
              [ngModel]="config['goToPage_pagination']['border_width'] | vhnumber"
              (ngModelChange)="config['goToPage_pagination']['border_width'] = $event + 'px'"
              (nzOnAfterChange)="updateConfig()">
            </nz-slider>
          </div>
          <!-- Chọn màu viền -->
          <div>
            <div class="config-name">
              <p style="width: 80%">{{'chon_mau_vien' | translate}}</p>
              <div style="width: 40%">
                <input class="input-color" style="width: 100%" [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true"
                  [cpOKButton]="true" [(colorPicker)]="config['goToPage_pagination']['border_color']"
                  [style.background]="config['goToPage_pagination']['border_color']"
                  (colorPickerClose)="updateConfig()"  type="button"/>
              </div>
            </div>
          </div>
          <!-- Bo tròn -->
          <div>
            <div class="config-name mb-0">
              <p>{{'bo_tron' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1"
                [ngModel]="config['goToPage_pagination']['border_radius'] | vhnumber"
                (ngModelChange)="config['goToPage_pagination']['border_radius'] = $event + 'px'"
                (nzBlur)="updateConfig()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
              [ngModel]="config['goToPage_pagination']['border_radius'] | vhnumber"
              (ngModelChange)="config['goToPage_pagination']['border_radius'] = $event + 'px'"
              (nzOnAfterChange)="updateConfig()">
            </nz-slider>
          </div>
        </div>
      </li>
      <!-- Cấu hình các phần tử bên trong -->
      <li nz-submenu nzTitle="{{'cau_hinh_phan_tu' | translate}}" [(nzOpen)]="openMenu.menu5"
        (nzOpenChange)="openHandler('menu5')">
        <div class="main-config">
          <!-- Màu nền -->
          <div class="config-name mt-0">
            <p>{{'mau_nen' | translate}}</p>
            <input class="input-color" type="button"
              [style.background]="class['frame-search-by-keyword__products--item']['background-color']"
              [cpOKButton]="true" [(colorPicker)]="class['frame-search-by-keyword__products--item']['background-color']"
              (colorPickerClose)="updateClass()" />
          </div>

          <app-borders-config [device]="device" [class]="class" [elementChoosing]="objectChoosing"
            [borderClass]="class['frame-search-by-keyword__products--item']" [id_object]="objectChoosing._id">
          </app-borders-config>

          <div class="mr-2 mt-2 mb-4 view-more">
            <p class="discover_text" (click)="openViewAll(stylesField[1])">{{'mo_rong' | translate}} &#8594;</p>
          </div>
        </div>
      </li>
      <!-- Cấu hình khi không tìm thấy sản phẩm -->
      <li nz-submenu nzTitle="{{'cau_hinh_khi_khong_tim_thay_san_pham' | translate}}" [(nzOpen)]="openMenu.menu6"
        (nzOpenChange)="openHandler('menu6')">
        <div class="d-flex justify-content-between align-items-center p-3">
          <p>{{'cau_hinh' | translate}}</p>
          <nz-switch [(ngModel)]="config['is_empty']" (ngModelChange)="updateConfig()"></nz-switch>
        </div>

        <ng-container *ngIf="config['is_empty']">
          <!-- chọn ngôn ngữ đa ngôn ngữ -->
          <div class="field-row mb-3">
            
          </div>
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'noi_dung' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata['no_data_' + functionService.selectedLanguageCode] | vhLanguage : 'no_data' : objectChoosing.component" 
                (ngModelChange)="objectChoosing.staticdata['no_data_' + functionService.selectedLanguageCode] = $event" 
                (blur)="updateStaticData()"></textarea>
            </mat-form-field>
          </div>
          <div class="config-font-size">
            <div class="field-row-font" style="width: 65%">
              <mat-form-field title="Font" style="width: 100%">
                <mat-label>Font</mat-label>
                <mat-select [(ngModel)]="class['frame-search-by-keyword__no-data']['font-family']"
                  (ngModelChange)="updateClass()" [(value)]="class['frame-search-by-keyword__no-data']['font-family']">
                  <mat-option *ngFor="let font of fonts" [value]="font.value">{{font.name}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="field-row-size" style="width: 35%">
              <mat-form-field title="Size" style="width: 100%">
                <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                <input matInput type="number"
                  [ngModel]="class['frame-search-by-keyword__no-data']['font-size'] | vhnumber"
                  (ngModelChange)="class['frame-search-by-keyword__no-data']['font-size'] =$event + 'px'"
                  (keyup.enter)="updateClass()" (blur)="updateClass()" />
              </mat-form-field>
            </div>
          </div>
          <div class="config-font">
            <p class="title-font">{{'kieu_chu' | translate}}</p>
            <div class="field-row">
              <button class="font-text-btn font-text-btn-bold" title="Bold" nz-button
                [nzType]=" class['frame-search-by-keyword__no-data']['font-weight'] == 'bold' ? 'primary' : 'default' "
                (click)="class['frame-search-by-keyword__no-data']['font-weight'] = class['frame-search-by-keyword__no-data']['font-weight'] == 'bold' ? '500' : 'bold'; updateClass() ">
                <span style="font-weight: 600">B</span>
              </button>
              <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                      class['frame-search-by-keyword__no-data']['font-style'] == 'italic'
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class['frame-search-by-keyword__no-data']['font-style'] =
                        class['frame-search-by-keyword__no-data']['font-style'] == 'normal'
                          ? 'italic'
                          : 'normal';
                      updateClass()
                    ">
                <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
              </button>
              <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                      class['frame-search-by-keyword__no-data']['text-decoration'] ==
                      'underline'
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class['frame-search-by-keyword__no-data']['text-decoration'] =
                        class['frame-search-by-keyword__no-data']['text-decoration'] ==
                        'none'
                          ? 'underline'
                          : 'none';
                      updateClass()
                    ">
                <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
              </button>
              <button class="font-text-btn font-text-btn-line-through" title="Line-through" nz-button [nzType]="
                      class['frame-search-by-keyword__no-data']['text-decoration'] ==
                      'line-through'
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class['frame-search-by-keyword__no-data']['text-decoration'] =
                        class['frame-search-by-keyword__no-data']['text-decoration'] ==
                        'none'
                          ? 'line-through'
                          : 'none';
                      updateClass()
                    ">
                <i nz-icon nzType="strikethrough" nzTheme="outline" style="font-size: 14px"></i>
              </button>
              <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                      class['frame-search-by-keyword__no-data']['text-transform'] ==
                      'uppercase'
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class['frame-search-by-keyword__no-data']['text-transform'] =
                        class['frame-search-by-keyword__no-data']['text-transform'] ==
                        'none'
                          ? 'uppercase'
                          : 'none';
                      updateClass()
                    ">
                <span>AB</span>
              </button>
              <div>
                <input id="color" title="Color" [cpOKButton]="true" [(colorPicker)]="class['frame-search-by-keyword__no-data']['color']"
                  [style.background]="class['frame-search-by-keyword__no-data']['color']" type="button"
                  (colorPickerClose)="updateClass()" [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
              </div>
            </div>
          </div>
          <div class="font-adjusting">
            <div class="row-spacing">
              <span class="title">{{'gian_cach_chu' | translate}}</span>
              <nz-input-number [nzMin]="0" [nzMax]="30" [ngStyle]="{ width: '40%' }" [ngModel]="
                    class['frame-search-by-keyword__no-data']['letter-spacing'] | vhnumber
                  " (nzBlur)="updateClass()" (ngModelChange)="
                    class['frame-search-by-keyword__no-data']['letter-spacing'] = $event + 'px'
                  "></nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="30"
              [ngModel]="class['frame-search-by-keyword__no-data']['letter-spacing'] | vhnumber"
              (nzOnAfterChange)="updateClass()" (ngModelChange)="
                  class['frame-search-by-keyword__no-data']['letter-spacing'] = $event + 'px'
                "></nz-slider>
          </div>
          <div class="font-adjusting">
            <div class="row-spacing">
              <span class="title"> {{'khoang_cach_dong' | translate}}</span>
              <nz-input-number [nzMin]="0" [nzMax]="3" [ngStyle]="{ width: '40%' }" [nzStep]="0.1"
                [(ngModel)]="class['frame-search-by-keyword__no-data']['line-height']"
                (nzBlur)="updateClass()"></nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="3" [nzStep]="0.1"
              [(ngModel)]="class['frame-search-by-keyword__no-data']['line-height']"
              (nzOnAfterChange)="updateClass()"></nz-slider>
          </div>
        </ng-container>
      </li>
      <li 
        nz-submenu nzTitle="{{'cach_tim_kiem' | translate}}" 
        [(nzOpen)]="openMenu.menu11" 
        (nzOpenChange)="openHandler('menu11')" >
        <mat-radio-group class="custom-radio" [(ngModel)]="staticdata.type_search" (ngModelChange)="updateStaticData()">
            <mat-radio-button value="ai_search" matTooltipClass="custom-tooltip" matTooltip="{{'su_dung_tri_tue_nhan_tao_de_tim_kiem_chinh_xac_hon_xu_ly_cac_tu_gan_dung_va_cung_cap_goi_y_thong_minh' | translate}}">
            {{'tim_kiem_ai' | translate}}
            </mat-radio-button>
            <mat-radio-button value="regular_search" matTooltipClass="custom-tooltip" matTooltip="{{'tim_kiem_co_ban_hien_thi_ket_qua_chinh_xac_theo_tu_khoa_ban_nhap_vao' | translate}}">
            {{'tim_kiem_tu_khoa' | translate}}
            </mat-radio-button>
        </mat-radio-group>
      </li>

      <!-- Cấu hình chữ thông báo kết quả -->
      <li
        nz-submenu
        nzTitle="{{'chu_thong_bao_ket_qua' | translate}}"
        [(nzOpen)]="openMenu.menu12"
        (nzOpenChange)="openHandler('menu12')"
      >

        <div class="show-notification-text">
          <p style="line-height: 1.5; line-height: normal;">
            {{'hien_thi' | translate}}
          </p>
          <nz-switch 
            [(ngModel)]="config['show_notification_text']"
            (ngModelChange)="updateConfig();"
          >
          </nz-switch>
        </div>

        <!-- chọn ngôn ngữ đa ngôn ngữ -->
        <div class="field-row mb-3">
          
        </div>

        <div class="config-text" style="width: 100%">
          <mat-form-field style="width: 100%">
            <mat-label> {{'noi_dung' | translate}}</mat-label>
            <textarea matInput
              [ngModel]="objectChoosing.staticdata['text_before_number_' + functionService.selectedLanguageCode] | vhLanguage : 'text_before_number' : objectChoosing.component" 
              (ngModelChange)="objectChoosing.staticdata['text_before_number_' + functionService.selectedLanguageCode] = $event" 
              (blur)="updateStaticData()"></textarea>
          </mat-form-field>
        </div>
        <div class="config-text" style="width: 100%">
          <mat-form-field style="width: 100%">
            <mat-label> {{'noi_dung' | translate}}</mat-label>
            <textarea matInput
              [ngModel]="objectChoosing.staticdata['text_after_number_' + functionService.selectedLanguageCode] | vhLanguage : 'text_after_number' : objectChoosing.component" 
              (ngModelChange)="objectChoosing.staticdata['text_after_number_' + functionService.selectedLanguageCode] = $event" 
              (blur)="updateStaticData()"></textarea>
          </mat-form-field>
        </div>
        
        <app-text-format-config
          [device]="device"
          [objectChoosing]="objectChoosing"
          [staticdata]="objectChoosing.staticdata"
          [class]="class"
          [config]="config"
          [textContentClass]="class['frame-search-by-keyword__notification-text']"
          [textWrapperClass]="class['frame-search-by-keyword__notification-text']"
        >
        </app-text-format-config>

        <div class="font-adjusting">
          <div class="row-spacing">
            <span class="title"> {{'khoang_cach_dong' | translate}}</span>
            <nz-input-number [nzMin]="0" [nzMax]="100" [ngStyle]="{ width: '40%' }" [nzStep]="0.1"
              [(ngModel)]="class['frame-search-by-keyword__notification-text']['line-height']" (nzBlur)="updateClass()"></nz-input-number>
          </div>
          <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="0.1" [(ngModel)]="class['frame-search-by-keyword__notification-text']['line-height']"
            (nzOnAfterChange)="updateClass()"></nz-slider>
        </div>
      
      </li>
      <!-- Cấu hình đường viền chung -->
      <li nz-submenu nzTitle="{{'duong_vien_chung' | translate}}" [(nzOpen)]="openMenu.menu4"
        (nzOpenChange)="openHandler('menu4')">
        <app-borders-config [device]="device" [class]="class" [borderClass]="class['frame-search-by-keyword']"
          [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
        </app-borders-config>

        <!-- Nút mở rộng -->
        <div class="mr-2 mb-4 view-more">
          <p class="discover_text" (click)="openViewAll(stylesField[0])">{{'mo_rong' | translate}} &#8594;</p>
        </div>
      </li>
      <!-- Cấu hình hiệu ứng -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMenu.menu8"
        (nzOpenChange)="openHandler('menu8')">
        <app-choose-animations-config [type]="type" [elementChoosing]="objectChoosing" (openAnimationDetail)="openAnimationDetail($event)"
          [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config"
          [staticdata]="objectChoosing.staticdata" [cursorClass]="class['frame-search-by-keyword']" [effect_hover]="effect_hover"
          [customize]="customize" [type]="'object'" [effectFileUsing]="'frame-products'">
        </app-choose-animations-config>
      </li>
      <!-- Cấu hình hiệu ứng -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMenu.menu15"
        (nzOpenChange)="openHandler('menu15')">
        <!-- Lựa chọn hiển thị cho các thiết bị -->
        <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
        </app-hide-show-config>
      </li>
    </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình frame -->
  <div class="view-more" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{currentViewAll.title | translate}}</span>
    <!-- Cấu hình chi tiết viền của frame -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config [device]="device" [class]="class"
        [borderRadiusClass]="class['frame-search-by-keyword']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>

    </div>
    <!-- Cấu hình chi tiết viền của phần tử trong frame -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config [device]="device" [class]="class"
        [borderRadiusClass]="class['frame-search-by-keyword__products--item']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>

      <!-- Bật đổ bóng -->

      <app-shadow-config [device]="device" [config]="config" [class]="class"
        [shadowClass]="class['frame-search-by-keyword__products--item']"
        [shadowConfig]="config['frame-search-by-keyword__products--item']" [objectChoosing]="objectChoosing">
      </app-shadow-config>
    </div>

    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 3">
      <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [staticdata]="objectChoosing.staticdata" [id_object]="objectChoosing._id" [customize]="customize" [device]="device"></app-animations-config>
    </div>
  </div>
</div>